import $api from "@/zapi-frontend/shared/api/axios";

async function downloadVaultBlob(url: string): Promise<void> {
  const response = await $api.get(url, { responseType: "blob" });

  const blob = response.data as Blob;
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;

  const disposition = response.headers["content-disposition"] as string | undefined;
  const fileNameMatch = disposition?.match(/filename="?([^"]+)"?/);
  anchor.download = fileNameMatch?.[1] || "vault.zip";

  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(objectUrl);
}

export async function downloadVaultAll(projectId: string): Promise<void> {
  return downloadVaultBlob(`/projects/${projectId}/documents/download-all`);
}

export async function downloadCaseBriefVaultAll(caseBriefId: string | number): Promise<void> {
  return downloadVaultBlob(`/chat/create-project-chat/case-brief/${caseBriefId}/documents/download-all`);
}
